import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-user',
  templateUrl: './icon-user.component.html',
  styles: []
})
export class IconUserComponent {}
